import { Component, Output, EventEmitter, Input } from '@angular/core';

import { UserProvider } from '../../providers/user/user';

import { User } from '../../models/models';

/*
TODO: Validazione vedi https://www.joshmorony.com/advanced-forms-validation-in-ionic-2/
*/

@Component({
	selector: 'user-add',
	templateUrl: 'user-add.html',
	//inputs:[]
})
export class UserAddComponent {
	/**
	Se impostato a true quando l'utente non esiste geenra un PIN dopo averlo creato
	*/
	@Input() public generatePin = false;
	@Output() public slide: number = 0;
	@Output() onAdd: EventEmitter<User> = new EventEmitter<User>();
	@Output() user: User = <User>{
		id: null,
		api_token: null,
		name: null,
		surname: null,
		email: null,
		fiscal_code: null,
		vat_number: null,
		type: null
	};

	public get isUserTypeValid(): boolean {
		switch (this.user.type) {
			case 'company':
			case 'person':
				return true;
		}
		return false;
	}
	public get isFiscalCodeValid() {
		switch (this.user.type) {
			case 'company':
				return true;
			case 'person':
				if (!this.user.fiscal_code) {
					return false;
				}
				return /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$/i.test(this.user.fiscal_code);
		}
		return false;
	}
	public get isVatNumberValid() {
		switch (this.user.type) {
			case 'company':
				if (!this.user.vat_number) {
					return false;
				}
				return /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/i.test(this.user.vat_number);
			case 'person':
				return true;
		}
		return false;
	}
	/*
	controlla che i campi per creare l'utente siano validi
	*/
	public get isUserCreateValid(): boolean {
		return this.isUserNameValid
			&& this.isUserSurnameValid
			&& this.isUserPhoneValid
			&& this.isUserCellValid
			&& this.isUserFaxValid
			&& this.isUserEmailValid
			&& this.isUserPecValid
	}
	/*
	controlla che sia impostato il tipo di utente e che il relativo identificativo fiscale sia valido
	*/
	public get isUserTypeValueValid(): boolean {
		switch (this.user.type) {
			case 'company':
				return this.isVatNumberValid;
			case 'person':
				return this.isFiscalCodeValid;
		}
		return false;
	}

	public get isUserNameValid(): boolean {
		if (!this.user.name) {
			return false;
		}
		switch (this.user.type) {
			case 'company':
				return /^[a-z 0-9']+$/i.test(this.user.name);
			case 'person':
				return /^[a-z ']+$/i.test(this.user.name);
		}
		return false;
	}
	public get isUserSurnameValid(): boolean {
		switch (this.user.type) {
			case 'company':
				return true;
			case 'person':
				if (!this.user.surname) {
					return false;
				}
				return /^[A-Z ']+$/i.test(this.user.surname);
		}
		return false;
	}

	public get isUserPhoneValid(): boolean {
		if (!this.user.phone) {
			return true;
		}
		return /^\+?\d{6,}$/i.test(this.user.phone);
	}
	public get isUserCellValid(): boolean {
		if (!this.user.cell) {
			return true;
		}
		return /^\+?\d{6,}$/i.test(this.user.cell);
	}
	public get isUserFaxValid(): boolean {
		if (!this.user.fax) {
			return true;
		}
		return /^\+?\d{6,}$/i.test(this.user.fax);
	}
	public get isUserEmailValid(): boolean {
		if (!this.user.email) {
			return true;
		}
		return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([A-Z\-0-9]+\.)+[A-Z]{2,}))$/i.test(this.user.email);
	}
	public get isUserPecValid(): boolean {
		if (!this.user.pec) {
			return true;
		}
		return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([A-Z\-0-9]+\.)+[A-Z]{2,}))$/i.test(this.user.pec);
	}



	/*
	Controlla che tutto il form sia ok, se nuovo utente deve avere tipo e dati altrimenti deve avere id utente
	*/
	public get isValid(): boolean {
		if (this.user.id) {
			return true;
		}
		return this.isUserTypeValid && this.isUserCreateValid;
	}

	/*
	@Output() status='start';
	*/
	/*
	@ViewChild('slider') slider: any;
	*/

	public isLoading = true;

	constructor(
		private users: UserProvider
	) {
	}

	ngAfterViewInit() {
		this.isLoading = false;
		console.log('user-add component, generatePin: ' + (this.generatePin ? 'true' : 'false'));
	}

	public back(step: string) {
		console.log('Back: ' + step);
		switch (step) {
			case 'start':
				this.user =
					<User>{//Va azzerato tranne il tipo
						id: null,
						name: null,
						surname: null,
						fiscal_code: null,
						vat_number: null,
						email: null,
						type: this.user.type//Mantiene il tipo
					};
				this.slideTo(0);
				break;
			case 'fiscal_identifier':
				this.user =
					<User>{//Va azzerato tranne il tipo e identificativo fiscale
						id: null,
						name: null,
						surname: null,
						fiscal_code: this.user.fiscal_code,
						vat_number: this.user.vat_number,
						email: null,
						type: this.user.type//Mantiene il tipo
					};
				this.slideTo(1);
				break;
			case 'user':
				if (this.user.id) {
					this.back('fiscal_identifier');
				} else {
					this.back('user_create');
				}
				break;
			case 'user_create'://controlla se esiste utente e poi switch tra create e confirm
				this.slideTo(2);
				break;
			case 'user_confirm':
				this.slideTo(3);
				break;
			default:
				console.error("Step precedente non valido: " + step);
				break;
		}
	}

	public next(step: string) {
		let self = this;

		/*
		let slider=this.slider;
		*/
		switch (step) {
			case 'fiscal_identifier'://rimanda a fiscal_code o vat_number in funzione del tipo di utente

				if (!this.user.type) {
					console.warn('Richiesta inserimento identificativo fiscale senza tipo di utente specificato');
					return;
				}
				this.slideTo(1);
				break;
			case 'user'://controlla se esiste utente e poi switch tra create e confirm

				switch (this.user.type) {
					case 'company':
						if (!this.isVatNumberValid) {
							console.warn('Richiesta inserimento dati azienda senza partita iva valida');
							return;
						}
						this.isLoading = true;
						this.users.getByVatNumber(this.user.vat_number).then((user) => {
							self.isLoading = false;
							if (!user) {
								self.slideTo(2);
							} else {
								self.user = user;
								self.slideTo(3);
							}
						}).catch((error) => {
							console.error("Errore cercando l'azienda per partita iva", error);
							self.isLoading = false;
						});
						break;

					case 'person'://Selezionato privato, ha immesso CF

						if (!this.isFiscalCodeValid) {
							console.warn('Richiesta inserimento dati utente senza codice fiscale valido');
							return;
						}
						this.isLoading = true;
						this.users.getByFiscalCode(this.user.fiscal_code)
							.then((user) => {
								self.isLoading = false;
								if (!user) {
									self.slideTo(2);
								} else {
									self.user = user;
									self.slideTo(3);
								}
							})
							.catch((error) => {
								console.error("Errore cercando l'utente per codice fiscale", error);
								self.isLoading = false;
							});

						break;
					default:
						console.error("Tipo di utente non valido per proseguire: " + this.user.type);
						break;
				}
				break;

			case 'user_create':
				if (!this.isUserTypeValueValid) {
					console.warn('Richiesta inserimento dati utente senza identificativo fiscale valido');
					return;
				}
				this.slideTo(2);
				break;

			case 'user_confirm':
				if (!this.user.id && !this.isUserCreateValid) {
					console.warn('Conferma dati nuovo utente con dati non validi');
					return;
				}
				this.slideTo(3);
				break;

			case 'end':
				if (!this.user.id) {
					//Non esiste, lo deve salvare
					this.isLoading = true;
					this.users.store(this.user, this.generatePin)
						.then(user => {
							self.user = user;
							self.onAdd.emit(user);
							self.isLoading = false;
							self.slideTo(4);
						}).catch(error => {
							console.error("Errore salvando l'utente", error);
							self.isLoading = false;
						});
				} else {//esiste, ha finito
					this.onAdd.emit(this.user);
					this.slideTo(4);
				}
				break;
			default:
				console.error("Step successivo non valido: " + step);
				break;
		}
	}


	private slideTo(i: number, slider: any = null) {
		this.slide = i;
	}
}



// WEBPACK FOOTER //
// ./src/components/user-add/user-add.ts